// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2R2Ts","inputDescription":"styles_inputDescription__3jbp5"};